import { render, staticRenderFns } from "./Blacklist.vue?vue&type=template&id=055f19d3"
import script from "./Blacklist.vue?vue&type=script&lang=js"
export * from "./Blacklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/TypXw3yGP/0/DHCCorporation/dhc-cloud-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('055f19d3')) {
      api.createRecord('055f19d3', component.options)
    } else {
      api.reload('055f19d3', component.options)
    }
    module.hot.accept("./Blacklist.vue?vue&type=template&id=055f19d3", function () {
      api.rerender('055f19d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Blacklist.vue"
export default component.exports